export default function testErrors(action$) {
  return action$
    .filter((action) => action.type === 'TRIGGER_ERROR_IN_EPICS')
    .map((action) => {
      throw new Error('TESTING ERRORS IN EPICS');
    });
}
